const getters = {
  token: state => state.user.token,
  uid: state => state.user.uid,
  avatar: state => state.user.avatar,
  is_problem_admin: state => state.user.IsProblemAdmin,
  name: state => state.user.name,
  baseRouter: state => state.userRouter.baseRouter,
  routeMap: state => state.userRouter.routeMap,
}
export default getters



// WEBPACK FOOTER //
// ./src/store/getters.js